import UserActionWrapper from "../UserActionWrapper";
import UserActionMenuComponent from "./UserActionMenuComponent";

export default UserActionWrapper(UserActionMenuComponent);
